import React from 'react';

import { Button, Card } from 'antd';

import IntlMessages from '@src/util/IntlMessages';
import Title from '@src/components/BoxContainer/components/Title';

import styles from './styles.module.less';

function linkProps(url) {
  if (!url) return {};
  const external = /^https?:\/\//.test(String(url));
  if (!external) return { href: url };
  return { href: url, rel: 'noopener noreferrer', target: '_blank' };
}

function resolveAction(item) {
  if (!item || typeof item !== 'object') return null;
  if (item.href && typeof item.href === 'object' && item.href.pathname != null) {
    const p = item.href.pathname;
    return { url: p, label: item.href.title, key: p };
  }
  if (item.pathname != null) {
    return { url: item.pathname, label: item.title, key: item.pathname };
  }
  return null;
}

export default function CardButtonAccess({ title, Icon, href, hrefs = [] }) {
  return (
    <Card
      title={<Title.SubTitle className={styles.title} value={title} />}
      className={styles.cardButtonAccess}
      cover={
        <div className={`gx-flex-column gx-justify-content-between gx-h-100 ${styles.cover}`}>
          {Icon && (
            <div
              className={`gx-flex-column gx-justify-content-center gx-align-items-center gx-h-100 ${styles.iconSlot}`}
              aria-hidden
            >
              <div className={styles.iconArtboard}>
                <Icon focusable="false" />
              </div>
            </div>
          )}
          {(href || hrefs.length > 0) && (
            <div className={`gx-pl-3 gx-pr-3 ${styles.actions}`}>
              {href && (
                <div className={styles.btnRow}>
                  <Button block type="primary" {...linkProps(href)}>
                    <IntlMessages id="button.enter" />
                  </Button>
                </div>
              )}
              {hrefs.length > 0 && (
                <div className={styles.hrefsContainer}>
                  {hrefs.map((item, i) => {
                    const act = resolveAction(item);
                    if (!act || !act.url) return null;
                    return (
                      <div className={styles.hrefsItem} key={act.key || `hrefs-${i}`}>
                        <Button type="primary" {...linkProps(act.url)}>
                          {act.label}
                        </Button>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </div>
      }
    />
  );
}
